module.exports = __webpack_public_path__ + "static/media/PTV_Thumbnail.5264a3ee.png";